import React from 'react';
import { Form, Input } from 'antd';
import RruleDaySelect from '../RruleDaySelect';
import { buildWeeklyRrule } from '../../helpers/rrule';

const EditableSubstituteRruleCell = ({ form, unitId, initialDays = [], validationMessage, required = true, placeholder }) => (
  <>
    <Form.Item
      name={['substitute_rrule', unitId]}
      initialValue={buildWeeklyRrule(initialDays)}
      rules={required ? [{ required: true, message: validationMessage }] : []}
      noStyle
    >
      <Input type="hidden" />
    </Form.Item>
    <RruleDaySelect
      name={['substitute_rrule_days', unitId]}
      initialDays={initialDays}
      showLabel={false}
      hasFeedback
      placeholder={placeholder}
      className="client-inform-inline-field"
      postChange={(rruleString) => form.setFieldValue(['substitute_rrule', unitId], rruleString)}
    />
  </>
);

export default EditableSubstituteRruleCell;
